// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"a2-z","subtitle":"b2-z","wrapper":"c2-z","leftArrow":"d2-z","rightArrow":"e2-z"};